<template>
  <div class="dashboard">
    <h1>Not Found<Br />(In Development?)</h1>
  </div>
</template>

<script>


export default {
  name: 'dashboard',
  methods: {

  }
}
</script>

<style scoped>
.dashboard {
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: space-around;
  height: calc(100vh - 48px);
  flex-direction: column;
}

.dashboard h1 {
  justify-self: center;
  color: #cfcfcf;
}
</style>